@if (options) {
  <highcharts-chart
    [Highcharts]="Highcharts"
    [constructorType]="'chart'"
    [options]="options"
    style="width: 100%; height: 100%; display: block"
  />
}
